import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TransactionDetailModal = ({ transaction, onClose }) => {
  if (!transaction) return null;

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    })?.format(amount);
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })?.format(new Date(date));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success/10 text-success';
      case 'pending':
        return 'bg-warning/10 text-warning';
      case 'failed':
        return 'bg-error/10 text-error';
      case 'processing':
        return 'bg-primary/10 text-primary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[2000] flex items-center justify-center p-4">
      <div className="w-full max-w-2xl bg-card border border-border rounded-lg shadow-elevation-3 max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <h2 className="text-xl font-bold text-foreground">İşlem Detayları</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-md transition-smooth"
            aria-label="Kapat"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-1">{transaction?.description}</h3>
              <p className="text-sm text-muted-foreground">{transaction?.reference}</p>
            </div>
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(transaction?.status)}`}>
              {transaction?.status === 'completed' ? 'Tamamlandı' :
               transaction?.status === 'pending' ? 'Beklemede' :
               transaction?.status === 'failed' ? 'Başarısız' :
               transaction?.status === 'processing' ? 'İşleniyor' : transaction?.status}
            </span>
          </div>

          <div className="p-4 bg-muted rounded-lg">
            <p className="text-sm text-muted-foreground mb-1">İşlem Tutarı</p>
            <p className="text-3xl font-bold text-foreground">{formatAmount(transaction?.amount)}</p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="p-4 bg-card border border-border rounded-lg">
              <p className="text-xs text-muted-foreground mb-1">İşlem Tarihi</p>
              <p className="text-sm font-medium text-foreground">{formatDate(transaction?.date)}</p>
            </div>
            <div className="p-4 bg-card border border-border rounded-lg">
              <p className="text-xs text-muted-foreground mb-1">İşlem Tipi</p>
              <p className="text-sm font-medium text-foreground capitalize">
                {transaction?.type === 'payment' ? 'Ödeme' :
                 transaction?.type === 'withdrawal' ? 'Para Çekme' :
                 transaction?.type === 'commission' ? 'Komisyon' :
                 transaction?.type === 'refund' ? 'İade' : transaction?.type}
              </p>
            </div>
          </div>

          {transaction?.commission && (
            <div className="p-4 bg-accent/5 border border-accent/20 rounded-lg">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Icon name="Percent" size={16} color="var(--color-accent)" />
                  <span className="text-sm font-medium text-foreground">Komisyon Ücreti</span>
                </div>
                <span className="text-sm font-bold text-foreground">{formatAmount(transaction?.commission)}</span>
              </div>
            </div>
          )}

          {transaction?.paymentMethod && (
            <div className="space-y-2">
              <h4 className="text-sm font-semibold text-foreground">Ödeme Yöntemi</h4>
              <div className="p-4 bg-card border border-border rounded-lg">
                <div className="flex items-center gap-3">
                  <Icon name="CreditCard" size={20} color="var(--color-primary)" />
                  <div>
                    <p className="text-sm font-medium text-foreground">{transaction?.paymentMethod?.name}</p>
                    <p className="text-xs text-muted-foreground">****{transaction?.paymentMethod?.last4}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {transaction?.notes && (
            <div className="space-y-2">
              <h4 className="text-sm font-semibold text-foreground">Notlar</h4>
              <p className="text-sm text-muted-foreground p-4 bg-muted rounded-lg">{transaction?.notes}</p>
            </div>
          )}

          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-foreground">İşlem Geçmişi</h4>
            <div className="space-y-2">
              {transaction?.history?.map((item, index) => (
                <div key={index} className="flex items-start gap-3 p-3 bg-card border border-border rounded-lg">
                  <div className="w-2 h-2 bg-primary rounded-full mt-1.5 flex-shrink-0" />
                  <div className="flex-1">
                    <p className="text-sm font-medium text-foreground">{item?.action}</p>
                    <p className="text-xs text-muted-foreground">{formatDate(item?.date)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="sticky bottom-0 bg-card border-t border-border p-6 flex gap-3">
          <Button
            variant="outline"
            iconName="Download"
            iconPosition="left"
            onClick={() => console.log('Fatura indir:', transaction?.reference)}
            className="flex-1"
          >
            Fatura İndir
          </Button>
          <Button
            variant="default"
            onClick={onClose}
            className="flex-1"
          >
            Kapat
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailModal;